import React from "react";

import "./ErrorBoundary.scss";

import bang from "./explosion.jpg";
import InfoPane from "../UI/InfoPane";

class AppErrorBoundary extends React.Component {
  // tslint:disable-next-line: function-name
  static getDerivedStateFromError(error: Error) {
    if (error?.message?.indexOf("user aborted") !== -1) {
      error.message = "Operation timed out; server not responding.";
    }
    return { error: true, message: error.message };
  }

  state = { error: false, message: "" };

  componentDidCatch(error: Error) {
    // tslint:disable-next-line: no-console
    console.error(`Error boundary caught: ${error}`);
  }

  render() {

    const Body = () => (
      <>
        <p>This is likely a server error. Please try refreshing this page in a few minutes.</p>
        <p>You can also bookmark this page and reload it later to continue your game where you left off.</p>
        <p className="gory">The gory details: {this.state.message}</p>
      </>
    );

    return this.state.error ? (
      <InfoPane
        className="app-error-boundary"
        title="Oops"
        subtitle="Something has gone horribly wrong inside the BlackBox!"
        imgSrc={bang}
        imgAlt="Error"
        bodyRender={Body}
      />
    ) : (
      this.props.children
    );
  }
}

export default AppErrorBoundary;
